var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.17
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1187_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.424 7.92L17.6681 13.5C17.4084 13.88 17.9079 14.34 18.2675 14.02L21.9634 10.8C22.0633 10.72 22.2031 10.78 22.2031 10.92V20.98C22.2031 21.12 22.0233 21.18 21.9434 21.08L10.7558 7.68C10.3962 7.24 9.8768 7 9.29745 7H8.89789C7.85905 7 7 7.86 7 8.92V23.08C7 24.14 7.85905 25 8.91787 25C9.57714 25 10.1964 24.66 10.556 24.08L14.3119 18.5C14.5716 18.12 14.0721 17.66 13.7125 17.98L10.0166 21.18C9.91676 21.26 9.77691 21.2 9.77691 21.06V11.02C9.77691 10.88 9.95671 10.82 10.0366 10.92L21.2242 24.32C21.5838 24.76 22.1232 25 22.6826 25H23.0821C24.141 25 25 24.14 25 23.08V8.92C25 7.86 24.141 7 23.0821 7C22.4029 7 21.7836 7.34 21.424 7.92Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1187_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/NEAR.981827dac1cd1bd278163ce1fcefb5f1.svg";
export { ForwardRef as ReactComponent };